<!-- 落地页管理-新增 -->
<template>
  <div style="padding-bottom: 50px">
    <!-- 标题 -->
    <!-- 头条/广点通/OPPO/VIVO/百度 -->
    <div class="page-title" style="margin-left: 30px">
      {{ page_title }}落地页
    </div>

    <div style="width: 80vw; margin: 30px auto 30px">
      <!-- <div class="form-cell-box">
			<div class="class-title" style="font-size: 18px;font-weight: bold;">选择新增类型<span class="required-hint">*</span></div>
				
			<a-select default-value="0" 
			:style="{'width': widths + 'px'}" 
			@change="addTypeChange" size="large">
				<a-select-option value="0">
					新增头条/广点通/OPPO/VIVO落地页
				</a-select-option>
				<a-select-option value="1">
					新增百度跳转页
				</a-select-option>
				<a-select-option value="2">
					新增360落地页
				</a-select-option>
				  
			</a-select>
		</div> -->

      <div class="form-cell-box">
        <div class="class-title">名称<span class="required-hint">*</span></div>

        <a-input
          v-model="r_title"
          placeholder="请输入"
          :style="{ width: widths + 'px' }"
        />
      </div>

      <div class="form-cell-box">
        <div class="class-title">渠道<span class="required-hint">*</span></div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_channel_id"
        >
          <a-select-option
            v-for="(item, index) in channel_idList"
            :key="index"
            :value="item.key"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          公众号<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          notFoundContent="请先选择: 渠道 ↑"
          @change="addChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_gzh_id"
        >
          <a-select-option
            v-for="(value, key) in gzhSelectList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <div class="form-cell-box" style="margin-top: -15px">
        <div class="class-title"></div>
        <div style="color: #999">这里的公众号需要与引导公众号一致</div>
      </div>

      <!-- 新增头条/广点通/OPPO/VIVO落地页 开始 -->
      <div class="form-cell-box">
        <div class="class-title">投放平台</div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeTA"
          :value="r_put_platform"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :disabled="put_disabled"
        >
          <!-- 头条-toutiao，广点通-gdt，OPPO-oppo，VIVO-vivo，百度-baidu，快手-kuaishou -->
          <a-select-option value="toutiao"> 头条 </a-select-option>
          <a-select-option value="gdt"> 广点通 </a-select-option>
          <a-select-option value="oppo"> OPPO </a-select-option>
          <a-select-option value="vivo"> VIVO </a-select-option>
          <a-select-option value="baidu"> 百度 </a-select-option>
          <a-select-option value="kuaishou"> 快手 </a-select-option>
          <a-select-option value="weibo"> 微博 </a-select-option>
        </a-select>
      </div>

      <div v-show="r_put_platform == 'toutiao'" class="form-cell-box">
        <div class="class-title">
          头条付费回传方式<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeG"
          :value="r_tt_report_type"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <a-select-option value="2"> 事件管理 </a-select-option>
          <a-select-option value="1"> 转化跟踪 </a-select-option>
        </a-select>
      </div>

      <!-- OPPO-广告账户 -->
      <div v-show="r_put_platform == 'oppo'" class="form-cell-box">
        <div class="class-title">
          (OPPO)广告账户<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeH"
          :value="r_media_account_id"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <a-select-option v-for="(value, key) in OPPOggList" :value="key">
            {{ value }}
          </a-select-option>
        </a-select>
      </div>
      <div v-show="r_put_platform == 'oppo'" class="form-cell-box">
        <div class="class-title">微信复制回传转化ID(JS跟踪)</div>

        <a-input
          v-model="r_convert_id"
          placeholder="请输入"
          :style="{ width: widths + 'px' }"
        />
      </div>

      <!-- VIVO广告账户 -->
      <div v-show="r_put_platform == 'vivo'" class="form-cell-box">
        <div class="class-title">
          (VIVO)广告账户<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeI"
          :value="r_media_account_id"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
        >
          <a-select-option v-for="(value, key) in VIVOggList" :value="key">
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <!-- 百度部分开始 -->
      <div v-show="r_put_platform == 'baidu'" class="form-cell-box">
        <div class="class-title">回传方式</div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="bdChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_bd_report_type"
        >
          <a-select-option value="0"> 一句话咨询 </a-select-option>
          <a-select-option value="1"> 营销通+付费阅读 </a-select-option>
        </a-select>
      </div>

      <div
        v-show="r_put_platform == 'baidu' && r_bd_report_type == '1'"
        class="form-cell-box"
      >
        <div class="class-title">是否回传加粉</div>

        <a-switch
          :checked="r_open_put"
          @change="bdChangeC"
          checked-children="打开"
          un-checked-children="关闭"
        />
      </div>

      <div
        v-show="r_put_platform == 'baidu' && r_bd_report_type == '0'"
        class="form-cell-box"
      >
        <div class="class-title">回传Token</div>

        <div>
          <div
            v-for="(item, index) in r_hc_token"
            :key="index"
            style="display: flex; align-items: center; margin-bottom: 10px"
          >
            <a-input
              v-model="item.value"
              style="display: block"
              placeholder="获取方式：百度后台，转化跟踪详情"
              :style="{ width: widths + 'px' }"
            />
            <div
              @click="delHcToken(item, index)"
              style="color: red; margin-left: 15px; cursor: pointer"
            >
              删除
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="r_put_platform == 'baidu' && r_bd_report_type == '0'"
        class="form-cell-box"
        style="margin-top: -15px"
      >
        <div class="class-title"></div>

        <a-button @click="addHcToken" size="small" type="primary">
          新增回传Token
        </a-button>
      </div>

      <div
        v-show="r_put_platform == 'baidu' && r_bd_report_type == '1'"
        class="form-cell-box"
      >
        <div class="class-title">
          新链路回传书城<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="bdChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          defaultValue="1"
        >
          <a-select-option value="1"> 乐读小说 </a-select-option>
        </a-select>
      </div>
      <!-- 百度部分结束 -->
      <!-- 新增头条/广点通/OPPO/VIVO落地页 结束 -->

      <!-- 页面元素设置 -->
      <div class="form-cell-box">
        <div class="class-title" style="font-size: 18px; font-weight: bold">
          页面元素设置
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          域名地址<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeF"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_put_url"
        >
          <a-select-option
            v-for="(value, key) in domainList"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>

      <!-- 头条部分 -->
      <div class="form-cell-box">
        <div class="class-title">
          落地页类型<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeTB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_jump_content_type"
        >
          <a-select-option
            v-if="
              r_put_platform == 'toutiao' ||
              r_put_platform == 'oppo' ||
              r_put_platform == 'vivo' ||
              r_put_platform == 'kuaishou'
            "
            value="1"
          >
            有内容落地页
          </a-select-option>
          <a-select-option
            v-if="
              r_put_platform == 'toutiao' ||
              r_put_platform == 'gdt' ||
              r_put_platform == 'baidu' ||
              r_put_platform == 'weibo'
            "
            value="2"
          >
            跳转页
          </a-select-option>
        </a-select>
      </div>

      <!-- 顶部图片 -->
      <div v-show="r_jump_content_type == '1'" class="form-cell-box">
        <div class="class-title">顶部图片</div>
        <div style="display: flex; align-items: center">
          <a-upload
            accept="image/*"
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 1,
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              :style="{ width: widths - 20 + 'px' }"
              style="height: 240px; object-fit: contain; box-sizing: border-box"
              alt="avatar"
            />
            <div
              v-else
              :style="{ width: widths - 20 + 'px' }"
              style="
                height: 240px;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                box-sizing: border-box;
              "
            >
              <a-icon
                :type="loading ? 'loading' : 'plus'"
                style="font-size: 26px"
              />
              <div class="" style="margin-top: 15px">选择图片</div>
            </div>
          </a-upload>
          <a-button
            @click="delTopImg"
            v-if="imageUrl"
            style="margin-left: 30px"
            size="small"
            type="danger"
            >删除</a-button
          >
        </div>
      </div>

      <div
        v-show="r_jump_content_type == '1'"
        class="form-cell-box"
        style="margin-bottom: 30px"
      >
        <div class="class-title" style="flex-shrink: 0">审核内容</div>
        <Editors
          :html_value="r_verify_content"
          @change_editor="changeEditorS"
          :style="{ width: widths + 'px' }"
        ></Editors>
      </div>

      <div
        v-show="r_jump_content_type == '1'"
        class="form-cell-box"
        style="margin-bottom: 30px"
      >
        <div class="class-title" style="flex-shrink: 0">投放内容</div>
        <Editors
          :html_value="r_put_content"
          @change_editor="changeEditorT"
          :style="{ width: widths + 'px' }"
        ></Editors>
      </div>

      <div v-show="r_jump_content_type == '1'" class="form-cell-box">
        <div class="class-title">
          背景色<span class="required-hint">*</span>
        </div>

        <a-radio-group
          name="radioGroup"
          @change="changeColor"
          :value="r_background_color"
          style="display: flex"
        >
          <a-radio value="#FFFFFF" style="display: flex; align-items: center">
            <div style="background-color: #ffffff">纯白</div>
          </a-radio>
          <a-radio value="#F6F2C4" style="display: flex; align-items: center">
            <div style="background-color: #f6f2c4">黄色</div>
          </a-radio>
          <a-radio value="#CBE5FC" style="display: flex; align-items: center">
            <div style="background-color: #cbe5fc">天空蓝</div>
          </a-radio>
          <a-radio value="#F1D6DF" style="display: flex; align-items: center">
            <div style="background-color: #f1d6df">樱花粉</div>
          </a-radio>
        </a-radio-group>
      </div>

      <div v-show="r_jump_content_type == '1'" class="form-cell-box">
        <div class="class-title">
          审核公司<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="r_company_name"
          placeholder="请输入"
          :style="{ width: widths + 'px' }"
        />
      </div>

      <div v-show="r_jump_content_type == '1'" class="form-cell-box">
        <div class="class-title">投放开关</div>

        <a-switch
          @change="addChangeTC"
          :checked="r_open_put"
          checked-children="打开"
          un-checked-children="关闭"
        />
      </div>

      <!-- 跳转设置 -->
      <div class="form-cell-box">
        <div class="class-title" style="font-size: 18px; font-weight: bold">
          跳转设置
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          跳转方式<span class="required-hint">*</span>
        </div>
        <a-select
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="addChangeTD"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_jump_type"
        >
          <a-select-option
            v-if="
              r_put_platform == 'baidu' ||
              r_put_platform == 'oppo' ||
              r_put_platform == 'vivo'
            "
            value="friend"
            >朋友圈分享</a-select-option
          >
          <a-select-option value="applets">小程序跳转</a-select-option>
          <a-select-option
            v-if="!['baidu', 'weibo'].includes(r_put_platform)"
            value="quickApplets"
            >安卓快应用跳转+IOS小程序跳转</a-select-option
          >
          <a-select-option
            v-if="
              r_put_platform == 'toutiao' ||
              r_put_platform == 'oppo' ||
              r_put_platform == 'vivo'
            "
            value="leduQuick"
            >安卓快应用跳转+IOS手动复制</a-select-option
          >
          <a-select-option
            v-if="!['baidu', 'weibo'].includes(r_put_platform)"
            value="work_wechat"
            >企业微信客服</a-select-option
          >
          <a-select-option
            v-if="
              r_put_platform == 'oppo' ||
              r_put_platform == 'vivo' ||
              r_put_platform == 'toutiao'
            "
            value="otherQuick"
            >外站快应用跳转</a-select-option
          >
          <a-select-option v-if="r_put_platform == 'toutiao'" value="copy"
            >手动复制</a-select-option
          >
        </a-select>
      </div>

      <div style="padding-left: 100px">
        <div
          style="
            background-color: #f7f7f9;
            padding: 30px 30px 10px;
            margin-bottom: 15px;
          "
        >
          <div style="display: flex; align-items: center; margin-bottom: 20px">
            <div style="font-size: 16px; margin-right: 20px">跳转设置</div>
            <div
              @click="ghzXcxSync"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <a-icon :spin="sync_true" style="color: #62a8ea" type="sync" />
              <div style="color: #62a8ea; margin-left: 10px">刷新</div>
            </div>
          </div>

          <div
            v-show="r_jump_type == 'applets' || r_jump_type == 'quickApplets'"
            class="form-cell-box"
            style="align-items: flex-start"
          >
            <div class="class-title">
              跳转小程序<span class="required-hint">*</span>
            </div>
            <div v-show="!ghzXcx_control" :style="{ width: widths + 'px' }">
              未设置，请设置后刷新。设置方式：前往授权公众号管理页面
            </div>
            <div v-show="ghzXcx_control" style="width: 100%">
              <div
                v-for="(item, index) in ghzXcxObj"
                :key="index"
                style="
                  background-color: #eff1f7;
                  width: 100%;
                  padding: 30px 15px 15px;
                  margin-bottom: 15px;
                  border-radius: 8px;
                "
              >
                <div class="form-cell-box">
                  <div class="class-title">
                    小程序<span class="required-hint">*</span>
                  </div>
                  <div>{{ item.applets_name }}</div>
                </div>
                <!-- <div class="form-cell-box">
							<div class="class-title">小程序跳转地址<span class="required-hint">*</span></div>
							<div>{{item.jump_url}}</div>
						</div> -->
                <div class="form-cell-box">
                  <div class="class-title">
                    小程序打开内容<span class="required-hint">*</span>
                  </div>
                  <div>{{ item.jump_type == 2 ? "扫二维码" : "引导页" }}</div>
                </div>
                <div class="form-cell-box">
                  <div class="class-title">是否启用</div>
                  <a-switch
                    :checked="!!item.is_using"
                    checked-children="打开"
                    un-checked-children="关闭"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            v-show="r_jump_type == 'work_wechat'"
            class="form-cell-box"
            style="align-items: flex-start"
          >
            <div class="class-title">
              跳转企业微信客服<span class="required-hint">*</span>
            </div>
            <div v-show="!ghzKf_control" :style="{ width: widths + 'px' }">
              未设置，请设置后刷新。设置方式：前往授权公众号管理页面
            </div>
            <div v-show="ghzKf_control" style="width: 100%">
              <div
                v-for="(item, index) in ghzKfObj"
                :key="index"
                style="
                  background-color: #eff1f7;
                  width: 100%;
                  padding: 30px 15px 15px;
                  margin-bottom: 15px;
                  border-radius: 8px;
                "
              >
                <div class="form-cell-box">
                  <div class="class-title">
                    客服名称<span class="required-hint">*</span>
                  </div>
                  <div>{{ item.name }}</div>
                </div>
                <div class="form-cell-box">
                  <div class="class-title">
                    客服链接<span class="required-hint">*</span>
                  </div>
                  <div>{{ item.kf_url }}</div>
                </div>
                <div class="form-cell-box">
                  <div class="class-title">客服消息主角名</div>
                  <div>{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-cell-box">
            <div class="class-title">
              公众号关注页链接<span class="required-hint">*</span>
            </div>

            <!-- <a-input v-model="ghzXcx_url" placeholder="请输入" :style="{'width': widths + 'px'}"  /> -->
            <div :style="{ width: widths + 'px' }">
              {{ ghzXcx_url }}
            </div>
          </div>
        </div>
      </div>
      <!-- 回传设置 -->
      <div class="form-cell-box" v-if="calcShowHc">
        <div class="class-title" style="font-size: 18px; font-weight: bold">
          回传设置
        </div>
      </div>

      <div class="form-cell-box" v-if="calcShowHc">
        <div class="class-title">回传比例</div>

        <a-input-number
          style="width: 100px"
          id="inputNumber"
          v-model="r_report_per"
          :min="0"
          :max="1000"
        />
      </div>

      <div class="form-cell-box" v-if="calcShowHc">
        <div class="class-title">回传最低金额（元）</div>

        <a-input-number
          style="width: 100px"
          id="inputNumber"
          v-model="r_report_money_limit"
          :min="0"
          :max="1000"
        />
      </div>

      <div class="form-cell-box" v-if="calcShowHc">
        <div class="class-title">回传小时限制</div>

        <a-input-number
          style="width: 100px"
          id="inputNumber"
          v-model="r_report_hour_limit"
          :min="0"
          :max="1000"
        />
      </div>

      <div class="form-cell-box" style="height: 40px" v-if="calcShowHc">
        <div class="class-title">只回传当天</div>
        <a-switch
          :checked="r_report_only_cur_day"
          @change="switchChangeA"
          checked-children="打开"
          un-checked-children="关闭"
        />
      </div>

      <div class="form-cell-box" style="height: 40px" v-if="calcShowHc">
        <div class="class-title">只回传一次</div>

        <a-switch
          :checked="r_report_only_once"
          @change="switchChangeB"
          checked-children="打开"
          un-checked-children="关闭"
        />
      </div>
      <div v-if="calcShowHc">
        <div
          v-show="page_title == '编辑' && r_put_platform == 'toutiao'"
          class="form-cell-box"
          style="height: 40px"
        >
          <div class="class-title">巨量付费2回传</div>

          <a-switch
            :checked="r_is_supply_active_pay"
            @change="switchChangeC"
            checked-children="打开"
            un-checked-children="关闭"
          />
        </div>
      </div>
      <div v-if="calcShowHc">
        <div v-show="r_put_platform != 'baidu'" class="form-cell-box">
          <div class="class-title">备注</div>

          <a-input
            v-model="r_memo"
            placeholder="请输入"
            :style="{ width: widths + 'px' }"
          />
        </div>
      </div>

      <div
        v-show="page_title == '编辑'"
        class="form-cell-box"
        style="margin-top: 30px"
      >
        <div class="class-title">同步修改其他落地页</div>

        <a-switch
          @change="syncLandChange"
          :checked="sync_land_control"
          checked-children="打开"
          un-checked-children="关闭"
        />
      </div>

      <div v-show="sync_land_control" class="form-cell-box">
        <div class="class-title">
          选择修改字段<span class="required-hint">*</span>
        </div>
        <a-select
          mode="multiple"
          show-search
          :style="{ width: widths + 'px' }"
          placeholder="请选择"
          @change="syncLandChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="r_sync_field"
        >
          <a-select-option v-for="(value, key) in syncFieldObj" :value="key">{{
            value
          }}</a-select-option>
        </a-select>
      </div>

      <div v-if="sync_land_control" class="form-cell-box">
        <div class="class-title">
          选择修改落地页<span class="required-hint">*</span>
        </div>
        <a-transfer
          :data-source="mockData"
          :titles="['同公众号下的其他落地页', '已选落地页']"
          :list-style="{
            width: `${(widths - 40) / 2}px`,
            height: '600px',
          }"
          :target-keys="targetKeys"
          :selected-keys="selectedKeys"
          :render="(item) => item.title"
          @change="handleChange"
          @selectChange="handleSelectChange"
          show-search
          @search="handleSearch"
        />
      </div>

      <div style="color: red; height: 23px; width: 100%">
        {{ add_form_hint }}
      </div>

      <div class="form-cell-box" style="margin-top: 30px; padding-left: 130px">
        <a-button
          @click="addRequest"
          :loading="add_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="addCloseDrawer">返回</a-button>
      </div>
    </div>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
import {
  putDataMenu,
  landPagePlatform,
  landPageJumpType,
  landPageChannelGzh,
  getPutDomain,
  landPageSixMedia,
  landOppoList,
  landVivoList,
  landGzhXcx,
  landAddUploadImage,
  landAddButton,
  landEditGet,
  landEditButton,
  landSyncField,
  landSameLink,
  landSyncUpdate,
} from "@/request/api";
import Editors from "@/components/Editors.vue";
export default {
  name: "landPageAdd_",
  components: {
    Editors,
  },
  data() {
    return {
      // 筛选条件部分
      filterData: {
        op_id: {
          // 投手
          list: [{}],
        },
        channel_id: {
          // 书城渠道
          list: [{}],
        },
        gzh_id: {
          // 公众号
          list: [{}],
        },
      }, // 筛选条件数组
      PlatformData: {}, // 落地页推广平台数据
      JumpTypeData: {}, // 落地页跳转方式数据

      channel_idList: [], // 渠道数据

      widths: 630, // 内容的宽度
      // 新增侧边栏
      add_visible: false,

      add_type: "0", // 新增类型。0为新增头条/广点通/OPPO/VIVO落地页。1为新增百度跳转页。2为新增360落地页
      add_drawer_title: "新增360落地页",
      add_form_hint: "", // 新增侧边栏的提示
      add_button_loading: false,
      gzhSelectList: {},
      mediaSelectList: {},

      domainList: {},

      // 头条部分

      sync_true: false, // 刷新的icon是否旋转
      ghzXcxObj: [{}], // 公众号绑定的小程序
      ghzXcx_url: "未设置，请设置后刷新。设置方式：前往授权公众号管理页面", // 公众号关注页链接
      ghzXcx_control: false, // 跳转设置控制
      ghzXcx_id: "", // 请求用的id
      // 企微客服
      ghzKfObj: [{}], // 跳转企业微信客服
      ghzKf_control: false, // 企业微信客服跳转设置控制

      OPPOggList: [], // oppo下拉列表
      VIVOggList: [], // VIVO下拉列表
      headers_token: "", // 图片上传用的token
      loading: false,
      imageUrl: "",

      r_title: "", // 落地页名称
      r_put_platform: "toutiao", // 投放平台。根据不同的投放平台控制页面显示不同的填写内容
      r_channel_id: undefined, // 渠道id
      r_gzh_id: undefined, // 公众号id

      r_convert_id: "", // 微信复制回传转化ID(JS跟踪)。非必填
      r_media_account_id: "", // 广告账户。投放平台vivo或者oppo必填项media_account_id媒体账号Id
      r_tt_report_type: "2", // 头条付费回传方式。上报类型，投放平台头条：默认值0和1转化跟踪，2代表事件

      r_background_color: "#FFFFFF", // 背景色

      r_put_url: undefined, // 投放域名id
      r_jump_content_type: "1", // 落地页类型。跳转内容方式1：内容页，2=跳转页

      r_company_name: "", // 审核公司。投放平台不为百度必填项company_name审核公司
      r_jump_type: undefined, // 跳转方式。跳转地址

      r_top_image: "", // 头部图片
      r_put_content: "", // 富文本-投放内容
      r_verify_content: "", // 富文本-审核内容
      r_open_put: false, // 投放开关。是否打开投放  0=否，1=是

      r_report_per: 100, // 回传比例
      r_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
      r_report_hour_limit: 24, // 回传小时限制
      r_report_only_cur_day: true, // 只回传当天 0=否，1=是
      r_report_only_once: true, // 只回传一次 0=否，1=是
      r_is_supply_active_pay: false, // 巨量付费2回传。1打开true，0是关闭false
      r_memo: "", // 备注/投放平台百度必填项memo回传Token

      // 百度
      r_bd_report_type: "0", // 回传方式
      r_hc_token: [
        // 回传Token
        { value: "" },
      ],

      search_button_loading: false,

      // 编辑
      r_link_id: "", // 编辑传过来的参数
      put_disabled: false, // 投放平台是否禁用
      page_title: "新增", // 页面标题

      syncFieldObj: {}, // 获取同步字段下拉
      sync_land_control: false, // 同步修改落地页开关
      r_sync_field: [],
      // 穿梭框数据
      mockData: [],
      targetKeys: [],
      selectedKeys: [],
    };
  },
  computed: {
    calcShowHc() {
      return this.r_put_platform !== "weibo";
    },
  },
  mounted() {
    let that = this;

    that.search_button_loading = true;

    that.widths = Math.floor(document.body.clientWidth * 0.8 - 210);
    console.log("that.widths", that.widths);

    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");

    putDataMenu().then((res) => {
      console.log("筛选条件", res.data.data);
      if (res.data.code == 0 || res.data.code == 200 || res.data.code == 8011) {
        that.filterData = res.data.data.filter;

        let fff = res.data.data.filter.channel_id.list;

        // 去重，避免有重复的key，然后报错。有重复内容用于select组件会报错。
        let obj = {};
        fff = fff.reduce(function (item, next) {
          obj[next.key] ? "" : (obj[next.key] = true && item.push(next));
          return item;
        }, []);
        console.log(fff);
        that.channel_idList = fff;
      } else {
        // if(res.data.code === 401){ // 未登录
        // 	localStorage.removeItem("access_token");
        // 	that.$router.replace({name: 'login',params: {type:'not_log'}})
        // }
        // else {
        that.$message.error(`错误：${res.data.msg}`);
        // }
      }
    });

    // 360媒体id下拉列表
    // landPageSixMedia().then(res=>{
    // 	console.log("360媒体id下拉列表",res.data);
    // 	that.mediaSelectList = res.data.data.list
    // })

    // 获取转换域名
    getPutDomain().then((res) => {
      console.log("获取转换域名", res.data);
      that.domainList = res.data.data.data;
    });

    landPagePlatform().then((res) => {
      console.log("落地页推广平台", res.data.data);
      that.PlatformData = res.data.data.list;
    });

    landPageJumpType().then((res) => {
      console.log("落地页跳转方式", res.data.data);
      that.JumpTypeData = res.data.data.list;
    });

    // oppo下拉列表
    landOppoList().then((res) => {
      console.log("oppo下拉列表", res);
      that.OPPOggList = res.data.data.list;
    });

    // VIVO下拉列表
    landVivoList().then((res) => {
      console.log("vivo下拉列表", res);
      that.VIVOggList = res.data.data.list;
    });

    console.log(this.$route.query);
    if (that.$route.query) {
      // 接收从小程序跳转码页面传过来的参数、小程序跳转码每日使用量页
      if (that.$route.query.link_id) {
        that.r_link_id = that.$route.query.link_id;
        that.put_disabled = true; // 平台选择禁用
        that.page_title = "编辑";

        landSyncField().then((res) => {
          console.log("获取同步字段下拉", res);
          that.syncFieldObj = res.data.data.list;
        });

        landSameLink(that.r_link_id).then((res) => {
          console.log("获取当前落地页相同类型的公众号", res);
          let obj_data = res.data.data.list;
          let oooData = [];
          for (let key in obj_data) {
            let obj = {
              key,
              title: obj_data[key],
              description: `description of content${obj_data[key]}`,
            };
            oooData.push(obj);
          }
          that.mockData = oooData;
        });

        // 获取编辑的内容
        landEditGet({
          id: that.r_link_id,
        }).then((res) => {
          console.log("获取编辑的内容", res.data.data.info);

          let editObject = res.data.data.info;
          that.r_title = editObject.title; // 名称
          that.r_channel_id = editObject.channel_id; // 渠道id
          that.addChangeA(editObject.channel_id); // 获取公众号选择器内容
          that.r_gzh_id = editObject.gzh_id.toString(); // 公众号id
          that.addChangeB(that.r_gzh_id); // 获取公众号相关内容
          that.r_put_platform = editObject.put_platform; // 投放平台
          // 选择不同的投放平台要对落地页类型进行状态重置
          if (
            that.r_put_platform == "toutiao" ||
            that.r_put_platform == "oppo" ||
            that.r_put_platform == "vivo" ||
            that.r_put_platform == "kuaishou"
          ) {
            this.r_jump_content_type = "1"; // 显示有内容落地页
          } else if (
            that.r_put_platform == "gdt" ||
            that.r_put_platform == "baidu"
          ) {
            this.r_jump_content_type = "2";
          }

          that.r_put_url = editObject.put_url.toString(); // 投放域名地址
          that.r_jump_type = editObject.jump_type; // 跳转方式

          that.r_report_per = editObject.report_per; // 回传比例
          that.r_report_money_limit = editObject.report_money_limit; // 回传最低金额
          that.r_report_hour_limit = editObject.report_hour_limit; // 回传小时限制
          that.r_background_color = editObject.background_color; // 背景色
          // 只回传当天 0=否，1=是
          if (editObject.report_only_cur_day == 1) {
            that.r_report_only_cur_day = true;
          } else {
            that.r_report_only_cur_day = false;
          }
          // 只回传一次 0=否，1=是
          if (editObject.report_only_once == 1) {
            that.r_report_only_once = true;
          } else {
            that.r_report_only_once = false;
          }

          // 落地页类型。跳转内容方式1：内容页，2=跳转页
          if (editObject.put_platform != "baidu") {
            that.r_jump_content_type = editObject.jump_content_type.toString();
          }

          // 选填内容
          if (editObject.top_image_path) {
            // 头部图片
            that.r_top_image = editObject.top_image_path;
            that.imageUrl = editObject.top_image || "";
          }
          if (editObject.put_content) {
            // 投放内容
            that.r_put_content = editObject.put_content;
          }
          if (editObject.verify_content) {
            // 审核内容
            that.r_verify_content = editObject.verify_content;
          }
          // 投放开关 or 百度里的 是否回传加粉
          if (editObject.open_put == 1) {
            that.r_open_put = true; // 打开
          } else {
            that.r_open_put = false; // 关闭
          }

          // 审核公司
          if (that.r_put_platform != "gdt" || that.r_put_platform != "baidu") {
            // 审核公司
            that.r_company_name = editObject.company_name; // 必填项
          }
          // 投放平台
          if (that.r_put_platform == "toutiao") {
            // 头条
            // 头条付费回传方式
            that.r_tt_report_type = editObject.tt_report_type.toString();
            // 巨量付费2回传
            if (editObject.is_supply_active_pay == 1) {
              // 打开

              that.r_is_supply_active_pay = true;
            } else {
              // 关闭
              that.r_is_supply_active_pay = false;
            }
            // 审核公司
            // that.r_company_name = editObject.company_name  // 必填项
          } else if (that.r_put_platform == "gdt") {
            // 广点通
          } else if (that.r_put_platform == "oppo") {
            // OPPO
            // OPPO-广告账户
            that.r_media_account_id = editObject.media_account_id.toString(); // 必填项
            // 微信复制回传转化ID(JS跟踪)
            that.r_convert_id = editObject.convert_id || ""; // 选填项
            // 审核公司
            // that.r_company_name = editObject.company_name  // 必填项
          } else if (that.r_put_platform == "vivo") {
            // VIVO
            //  VIVO广告账户
            that.r_media_account_id = editObject.media_account_id.toString(); // 必填项
            // 审核公司
            // that.r_company_name = editObject.company_name  // 必填项
          }
          // 百度
          if (that.r_put_platform == "baidu") {
            that.r_bd_report_type = editObject.bd_report_type.toString();
            // 备注 or 投放平台百度必填项memo回传Token
            if (that.r_bd_report_type == "0") {
              // console.log("JSON.parse(editObject.memo)",JSON.parse(editObject.memo))
              let arr = JSON.parse(editObject.memo);
              let mmm = [];
              arr.forEach((res) => {
                let obj = {
                  value: res,
                };

                mmm.push(obj);
              });
              that.r_hc_token = mmm;
            }
          } else {
            that.r_memo = editObject.memo; // 备注 or 投放平台百度必填项memo回传Token
          }

          setTimeout(() => {
            that.search_button_loading = false;
          }, 300);
        });
      } else {
        setTimeout(() => {
          that.search_button_loading = false;
        }, 500);
      }
    } else {
      setTimeout(() => {
        that.search_button_loading = false;
      }, 500);
    }
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 新增部分开始------
    // 显示新增侧边栏
    addShowDrawer() {
      let that = this;
      // 360媒体id下拉列表
      landPageSixMedia().then((res) => {
        console.log("360媒体id下拉列表", res.data);
        that.mediaSelectList = res.data.data.list;
      });

      // 获取转换域名
      getPutDomain().then((res) => {
        console.log("获取转换域名", res.data);
        that.domainList = res.data.data.data;
      });

      this.add_visible = true;
    },
    // 选择新增类型
    addTypeChange(e) {
      console.log(e);
      this.add_type = e;
      if (e == "0") {
        this.add_drawer_title = "新增头条/广点通/OPPO/VIVO落地页";
      } else if (e == "1") {
        this.add_drawer_title = "新增百度跳转页";
      } else if (e == "2") {
        this.add_drawer_title = "新增360落地页";
      }
    },
    // 新增侧边栏-选择渠道
    addChangeA(e) {
      let that = this;
      console.log(e);
      that.r_gzh_id = undefined;
      that.r_channel_id = e;
      // 渠道公众号
      landPageChannelGzh({ channel_id: e }).then((res) => {
        console.log("渠道公众号", res.data.data);
        that.gzhSelectList = res.data.data.list;
      });
    },
    // 选择公众号
    addChangeB(e) {
      let that = this;
      console.log(e);
      this.ghzXcx_id = e;
      this.r_gzh_id = e;
      this.ghzXcxSync();
    },
    // 刷新
    ghzXcxSync() {
      let that = this;
      that.sync_true = true;
      landGzhXcx({
        id: that.ghzXcx_id,
        type: "1", // 默认type=0，根据运营公众号id获取绑定小程序，type=1，根据投放公众号id获取绑定小程序
      }).then((res) => {
        that.sync_true = false;
        console.log("公众号绑定的小程序", res);
        that.ghzXcx_url =
          res.data.data.jump_url ||
          "未设置，请设置后刷新。设置方式：前往授权公众号管理页面";
        // 小程序的数据
        if (res.data.data.list.length > 0) {
          that.ghzXcxObj = res.data.data.list;
          let kkk = Object.keys(res.data.data.list[0]);
          if (kkk.length > 0) {
            that.ghzXcx_control = true;
          } else {
            that.ghzXcx_control = false;
          }

          // that.ghzKfObj = res.data.data.kf_list
          // let fff = Object.keys(res.data.data.kf_list[0])
          // if(fff.length > 0){
          // 	that.ghzKf_control = true
          // }
          // else {
          // 	that.ghzKf_control = false
          // }
        } else {
          that.ghzXcxObj = [{}];
          that.ghzXcx_control = false;
        }

        // 企业微信客服的数据
        if (res.data.data.kf_list.length > 0) {
          that.ghzKfObj = res.data.data.kf_list;
          let fff = Object.keys(res.data.data.kf_list[0]);
          if (fff.length > 0) {
            that.ghzKf_control = true;
          } else {
            that.ghzKf_control = false;
          }
        } else {
          that.ghzKfObj = [{}];
          that.ghzKf_control = false;
        }
      });
    },

    // 头条付费回传方式
    addChangeG(e) {
      console.log(e);
      this.r_tt_report_type = e;
    },
    //  OPPO-广告账户
    addChangeH(e) {
      console.log(e);
      this.r_media_account_id = e;
    },
    //  VIVO广告账户
    addChangeI(e) {
      console.log(e);
      this.r_media_account_id = e;
    },

    // 新增侧边栏-投放域名地址
    addChangeF(e) {
      this.r_put_url = e;
    },

    // 新增头条/广点通/OPPO/VIVO
    addChangeTA(e) {
      // 投放平台
      // 选择不同的投放平台要对落地页类型进行状态重置
      if (e == "toutiao" || e == "oppo" || e == "vivo" || e == "kuaishou") {
        this.r_jump_content_type = "1"; // 显示有内容落地页
      } else if (e == "gdt" || e == "baidu" || e == "weibo") {
        this.r_jump_content_type = "2";
      }

      // 由于r_open_put被 投放开关 和 百度里的 是否回传加粉共用了，所以这里要针对不同平台作出区分
      if (e == "baidu") {
        this.r_open_put = true; // 百度里的 是否回传加粉 默认开启
      } else {
        this.r_open_put = false; // 投放开关 默认关闭
      }

      if (e == "oppo" || e == "vivo") {
        this.r_media_account_id = undefined;
      }
      this.r_jump_type = undefined; // 跳转方式清空，重新选
      this.r_put_platform = e;
    },
    addChangeTB(e) {
      // 落地页类型
      this.r_jump_content_type = e;
    },
    addChangeTC(e) {
      // 投放开关
      this.r_open_put = e;
    },
    addChangeTD(e) {
      // 跳转方式
      this.r_jump_type = e;
    },

    // 选择背景色
    changeColor(e) {
      // console.log(e);
      this.r_background_color = e.target.value;
    },

    // 同步修改落地页开关
    syncLandChange(e) {
      this.sync_land_control = e;
    },
    syncLandChangeB(e) {
      this.r_sync_field = e;
    },

    // 顶部图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      console.log("beforeUpload", file);

      // if(this.add_wx_kf_account_id){
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
      // }
      // else {
      // 	this.$message.warning('请先选择企业');
      // }
    },
    uploadChange(info) {
      // console.log("图片请求",info);
      let that = this;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        console.log("图片请求done", info);
        if (info.file.response) {
          // 图片上传成功，有内容返回
          // this.add_wx_kf_media_id = info.file.response.data.media_id
          that.r_top_image = info.file.response.data.path;
          that.imageUrl = info.file.response.data.url;
          that.loading = false;
          // getBase64(info.file.originFileObj, imageUrl => {
          //   this.imageUrl = imageUrl;
          //   this.loading = false;
          // });
        } else {
          this.imageUrl = "";
          this.loading = false;
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.imageUrl = "";
        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },
    // 删除选择的图片
    delTopImg() {
      this.imageUrl = "";
      this.r_top_image = "";
    },
    switchChangeA(e) {
      // 只回传当天
      this.r_report_only_cur_day = e;
    },
    switchChangeB(e) {
      // 只回传一次
      this.r_report_only_once = e;
    },
    switchChangeC(e) {
      // 巨量付费2回传
      // console.log(e);
      // this.r_is_supply_active_pay = e
    },
    changeEditorS(e) {
      // 审核内容
      // console.log(e);
      this.r_verify_content = e;
    },
    changeEditorT(e) {
      // 投放内容
      // console.log(e);
      this.r_put_content = e;
    },

    // 百度部分
    bdChangeA(e) {
      // 回传方式
      if (e == "1") {
        // 营销通+付费阅读
        this.r_hc_token = [{ value: "" }];
      }
      this.r_bd_report_type = e;
    },
    bdChangeB(e) {},
    bdChangeC(e) {
      // 是否回传加粉
      this.r_open_put = e;
    },
    // 新增回传token
    addHcToken() {
      let obj = {
        value: "",
      };
      this.r_hc_token.push(obj);
    },
    // 删除新增回传token
    delHcToken(e, index) {
      if (this.r_hc_token.length > 1) {
        this.r_hc_token.splice(index, 1);
      } else {
        this.$message.warning("至少保留一个内容");
      }
    },

    // 新增侧边栏确认按钮
    addRequest() {
      let that = this;
      // console.log(that.r_put_content);
      // console.log(that.r_verify_content);
      // console.log("that.r_top_image",that.r_top_image);
      console.log("targetKeys", that.targetKeys);
      // return
      let bbb_token = true;
      if (that.r_put_platform == "baidu") {
        that.r_hc_token.forEach((res) => {
          if (!res.value) {
            bbb_token = false; // 回传token为空
          }
        });
      }
      console.log("bbb_token", bbb_token);
      // 检查必填项
      if (!that.r_title) {
        that.$message.warning("请填写落地页名称");
      } else if (!that.r_channel_id) {
        that.$message.warning("请选择渠道");
      } else if (!that.r_gzh_id) {
        that.$message.warning("请选择公众号");
      } else if (!that.r_tt_report_type && that.r_put_platform == "toutiao") {
        that.$message.warning("请选择头条付费回传方式");
      } else if (
        !that.r_media_account_id &&
        (that.r_put_platform == "oppo" || that.r_put_platform == "vivo")
      ) {
        that.$message.warning("请选择广告账户");
      } else if (!that.r_put_url) {
        that.$message.warning("请选择投放域名地址");
      } else if (!that.r_jump_content_type) {
        that.$message.warning("请选择落地页类型");
      } else if (!that.r_company_name && that.r_jump_content_type == "1") {
        that.$message.warning("请输入审核公司");
      } else if (!that.r_jump_type) {
        that.$message.warning("请选择跳转方式");
      } else if (
        that.r_put_platform == "baidu" &&
        that.r_bd_report_type == "0" &&
        !bbb_token
      ) {
        that.$message.warning("请填写回传Token");
      } else if (
        that.page_title == "编辑" &&
        that.sync_land_control &&
        that.r_sync_field.length == 0
      ) {
        that.$message.warning("请选择修改字段");
      } else if (
        that.page_title == "编辑" &&
        that.sync_land_control &&
        that.targetKeys.length == 0
      ) {
        that.$message.warning("请选择修改落地页");
      } else {
        that.search_button_loading = true;
        console.log("else");
        // 必填内容
        let r_data = {
          applets: [], // 这是老的逻辑，这里就不管他了
          background_color: that.r_background_color, // 背景色

          title: that.r_title, // 落地页名称
          channel_id: that.r_channel_id, // 渠道id
          gzh_id: that.r_gzh_id, // 公众号id
          put_platform: that.r_put_platform, // 投放平台

          put_url: that.r_put_url, // 投放域名地址

          jump_type: that.r_jump_type, // 跳转方式

          report_per: that.r_report_per, // 回传比例
          report_money_limit: that.r_report_money_limit, // 回传最低金额
          report_hour_limit: that.r_report_hour_limit, // 回传小时限制
          // report_only_cur_day: that.r_report_only_cur_day, // 只回传当天 0=否，1=是
          // report_only_once: that.r_report_only_once, // 只回传一次 0=否，1=是
        };
        if (that.r_put_platform != "baidu") {
          r_data.jump_content_type = that.r_jump_content_type; // 落地页类型。跳转内容方式1：内容页，2=跳转页
        }

        // 只回传当天
        if (that.r_report_only_cur_day) {
          r_data.report_only_cur_day = 1; // 打开
        } else {
          r_data.report_only_cur_day = 0; // 关闭
        }
        // 只回传一次r_report_only_once
        if (that.r_report_only_once) {
          r_data.report_only_once = 1; // 打开
        } else {
          r_data.report_only_once = 0; // 关闭
        }

        // 选填内容
        if (that.r_top_image) {
          // 头部图片
          r_data.top_image = that.r_top_image;
        }
        if (that.r_put_content) {
          // 投放内容
          r_data.put_content = that.r_put_content;
        }
        if (that.r_verify_content) {
          // 审核内容
          r_data.verify_content = that.r_verify_content;
        }
        // 投放开关 or 百度里的 是否回传加粉
        if (that.r_open_put) {
          r_data.open_put = 1; // 打开
        } else {
          r_data.open_put = 0; // 关闭
        }

        if (that.r_put_platform != "gdt" || that.r_put_platform != "baidu") {
          // 审核公司
          r_data.company_name = that.r_company_name; // 必填项
        }

        // 投放平台
        if (that.r_put_platform == "toutiao") {
          // 头条
          // 头条付费回传方式
          r_data.tt_report_type = that.r_tt_report_type;
          // 巨量付费2回传
          if (that.r_is_supply_active_pay) {
            // 打开
            r_data.is_supply_active_pay = 1;
          } else {
            // 关闭
            r_data.is_supply_active_pay = 0;
          }
          // 审核公司
          // r_data.company_name = that.r_company_name  // 必填项
        } else if (that.r_put_platform == "gdt") {
          // 广点通
        } else if (that.r_put_platform == "oppo") {
          // OPPO
          // OPPO-广告账户
          r_data.media_account_id = that.r_media_account_id; // 必填项
          // 微信复制回传转化ID(JS跟踪)
          r_data.convert_id = that.r_convert_id || ""; // 选填项
          // 审核公司
          // r_data.company_name = that.r_company_name  // 必填项
        } else if (that.r_put_platform == "vivo") {
          // VIVO
          //  VIVO广告账户
          r_data.media_account_id = that.r_media_account_id; // 必填项
          // 审核公司
          // r_data.company_name = that.r_company_name  // 必填项
        }
        // 百度
        if (that.r_put_platform == "baidu") {
          r_data.bd_report_type = that.r_bd_report_type;
          if (that.r_bd_report_type == "0") {
            let mmm = [];
            that.r_hc_token.forEach((res) => {
              // console.log("");
              mmm.push(res.value);
            });
            // console.log("mmm",JSON.stringify(mmm));
            r_data.memo = JSON.stringify(mmm); // 备注 or 投放平台百度必填项memo回传Token
          }
        } else {
          r_data.memo = that.r_memo; // 备注 or 投放平台百度必填项memo回传Token
        }
        console.log("r_data", r_data);

        if (that.page_title == "新增") {
          landAddButton(r_data).then((res) => {
            console.log("新增提交按钮", res);
            that.search_button_loading = false;
            if (
              res.data.code === 0 ||
              res.data.code === 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("新增成功");
              setTimeout(() => {
                that.$router.replace({ name: "landPage_", params: {} });
              }, 1000);
            } else {
              // if(res.data.code === 401){ // 未登录
              // 	localStorage.removeItem("access_token");
              // 	that.$router.replace({name: 'login',params: {type:'not_log'}})
              // }
              // else {
              that.$message.error(`错误：${res.data.msg}`);
              // }
            }
          });
        } else if (that.page_title == "编辑") {
          r_data.id = that.r_link_id;
          landEditButton(r_data).then((res) => {
            console.log("编辑提交按钮", res);
            that.search_button_loading = false;
            if (
              res.data.code === 0 ||
              res.data.code === 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("编辑成功");

              if (that.sync_land_control) {
                let nnn = 100;
                that.search_button_loading = true;

                if (that.targetKeys.length <= nnn) {
                  landSyncUpdate({
                    id: that.r_link_id,
                    field: that.r_sync_field,
                    link_ids: that.targetKeys,
                  }).then((res) => {
                    that.search_button_loading = false;
                    console.log("同步落地页", res);
                    that.$message.success("同步修改其他落地页成功");
                    setTimeout(() => {
                      that.$router.replace({ name: "landPage_", params: {} });
                    }, 500);
                  });
                } else {
                  // 内容过多，进行分割
                  let for_number = Math.ceil(that.targetKeys.length / nnn);
                  let i = 0;

                  function updateLand() {
                    const ppp = new Promise((resolve, reject) => {
                      landSyncUpdate({
                        id: that.r_link_id,
                        field: that.r_sync_field,
                        link_ids: that.targetKeys.splice(0, nnn),
                      }).then((res) => {
                        console.log("同步落地页", res);
                        console.log("for_number", for_number);
                        console.log("i", i);
                        i++;
                        if (i == for_number) {
                          // 表示循环完毕
                          console.log("停止----------------");
                          reject("停止");
                        } else {
                          console.log("继续----------------");
                          resolve("继续");
                        }
                      });
                    });

                    ppp.then(
                      (value) => {
                        updateLand();
                      },
                      (reason) => {
                        // promise状态-失败
                        that.search_button_loading = false;
                        that.$message.success("同步修改其他落地页成功");
                        setTimeout(() => {
                          that.$router.replace({
                            name: "landPage_",
                            params: {},
                          });
                        }, 500);
                      }
                    );
                  }
                  updateLand();
                }
              } else {
                setTimeout(() => {
                  that.$router.replace({ name: "landPage_", params: {} });
                }, 1000);
              }
            } else {
              // if(res.data.code === 401){ // 未登录
              // 	localStorage.removeItem("access_token");
              // 	that.$router.replace({name: 'login',params: {type:'not_log'}})
              // }
              // else {
              that.$message.error(`错误：${res.data.msg}`);
              // }
            }
          });
        }
      }
    },
    // 新增侧边栏取消按钮
    addCloseDrawer() {
      this.$router.replace({ name: "landPage_", params: {} });
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;

      // console.log('targetKeys: ', nextTargetKeys);
      // console.log('direction: ', direction);
      // console.log('moveKeys: ', moveKeys);
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

      // console.log('sourceSelectedKeys: ', sourceSelectedKeys);
      // console.log('targetSelectedKeys: ', targetSelectedKeys);
    },
    handleDisable(disabled) {
      this.disabled = disabled;
    },
    handleSearch(dir, value) {
      console.log("search:", dir, value);
    },
  },
};
</script>

<style scoped>
.form-cell-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.class-title {
  position: relative;
  font-size: 14px;
  margin-right: 25px;
  width: 190px;
  color: #333;
  text-align: right;
}

/* 必填提示 */
.required-hint {
  color: red;
  position: absolute;
  right: -8px;
}
</style>
